import styled from 'styled-components';

export const SpinnerSpacing = styled.div`
  display: inline-flex;
  height: 28px;
  align-items: center;
  margin-left: 15px;
`;
